import { torontoDateParts } from "./utils";

export function pad2(n) {
  return String(n).padStart(2, "0");
}

/** Shift a "YYYY-MM-DD" date by `n` days (negative goes back). */
export function addDaysISO(iso, n) {
  if (!iso) return iso;
  const [y, m, d] = iso.split("-").map(Number);
  const date = new Date(y, m - 1, d + n);
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
}

/**
 * Build a { from, to, year, month } range covering a full YYYY-MM month.
 * Caps `to` at today when the month is the current month. Returns null
 * for an empty or invalid month string.
 */
export function getMonthRange(monthStr) {
  if (!monthStr) return null;
  const [y, m] = monthStr.split("-").map(Number);
  if (!y || !m) return null;
  const from = `${y}-${pad2(m)}-01`;
  const lastDay = new Date(y, m, 0).getDate();
  const today = torontoDateParts();
  const isCurrentMonth = today.year === y && today.month === m;
  const toDay = isCurrentMonth ? Math.min(today.day, lastDay) : lastDay;
  const to = `${y}-${pad2(m)}-${pad2(toDay)}`;
  return { from, to, year: y, month: m };
}
